import React from "react";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import RowDetail from "../components/detail/RowDetail";
import RowDetailList from "../components/detail/RowDetailList";

interface IProps {
  NoticeResult: INoticeDetails;
}

const Bloc7: React.FC<IProps> = ({ NoticeResult }) => {
  return (
    <>
    <div className="card" style={{ textAlign: 'left' }}>
              <div className="col-sm-12 card-body">
                <RowDetail titre="Thème" donnee={NoticeResult?.Theme} />
                {/*Retire Aucun Genre GAUC000 */}
                {NoticeResult?.genres?.filter(g => g.GenreId !== 'GAUC000').length > 0 && (
                  <RowDetailList titre="Genre" titreCol="4" donneeCol="8" donnees={NoticeResult?.genres?.filter(g => g.GenreId !== 'GAUC000').map(x => x.LibelleGenre)} />
                )}
                {/*Retire Sans Public PS0400 */}
                {NoticeResult?.publics?.filter(g => g.PublicId !== 'PS0400').length > 0 && (
                  <RowDetailList titre="Public" titreCol="4" donneeCol="8" donnees={NoticeResult?.publics?.filter(g => g.PublicId !== 'PS0400').map(x => x.LibellePublic)} />
                )}
                {NoticeResult?.deweys?.length > 0 && (
                  <RowDetailList titre="Dewey" titreCol="4" donneeCol="8" donnees={NoticeResult?.deweys?.map(x => x.LibelleDewey)} />
                )} 
                {NoticeResult?.vedettesMatieres?.length>0 && (
                  <>
                  <div className="row">
                    <div className={`col-4 pae-detail-label`} style={{ textAlign: 'left' }}>
                      <b>Sujet </b>
                    </div>
                    <div className={`col-8`}>
                      {NoticeResult.vedettesMatieres?.map((itemVedette, indexVedette) => (
                        <div className="row" key={indexVedette}>
                          <div className={`col-12 pae-detail-label`} style={{ textAlign: 'left' }}>
                            {itemVedette?.Autorites?.map((itemAutorite) => itemAutorite?.FormeBibAutorite).join(' - ')}
                          </div>
                        </div>
                      ))}
                      {NoticeResult.vedettesMatieres?.map((itemVedette, indexVedette) => (
                        <div className="row" key={indexVedette}>
                          <div className={`col-12 pae-detail-label`} style={{ textAlign: 'left' }}>
                            {itemVedette?.Autorites?.map((itemAutorite) => itemAutorite?.FormeBibAutorite).join(' - ')}
                          </div>
                        </div>
                      ))}
                    </div>
                </div> 
                  </>
                )}        
              </div>
      </div>      
    </>
  );
};

export default Bloc7;
